export default (state = "", action) => {
  if (action.type === "INPUT_DOMAIN") {
    return action.payload;
  }
  return state;
};
